import React from 'react'

import Tooltip from 'components/Tooltip'
import { StyledDocumentCardIcons, StyledIcon } from './DocumentCardIcons.styles'
import { DocumentSharingStatus } from 'modules/shares/utils/getDocumentSharingStatus'

import { ReactComponent as SymbolIcon } from 'icons/link-library-16.svg'
import { ReactComponent as TwoPersonsIcon } from 'icons/persons-two-16.svg'
import { ReactComponent as LockIcon } from 'icons/lock-16.svg'
import { ReactComponent as GlobeIcon } from 'icons/globe-16.svg'

interface IconWithTooltipProps {
  children: React.ReactNode
  content: React.ReactNode
}

const IconTooltip = ({ children, content }: IconWithTooltipProps) => {
  return (
    <Tooltip placement="bottom-start" content={content}>
      {children}
    </Tooltip>
  )
}

const sharedStatusToIconMap: Record<DocumentSharingStatus, React.ReactNode> = {
  ANYONE_WITH_LINK: (
    <IconTooltip content={<span>Anyone with the link can access</span>}>
      <StyledIcon as={GlobeIcon} aria-label="Publicly shared icon" />
    </IconTooltip>
  ),
  GUESTS: (
    <IconTooltip content={<span>Selected Guests can access</span>}>
      <StyledIcon as={TwoPersonsIcon} aria-label="Guests icon" />
    </IconTooltip>
  ),
  SELECTED_WORKSPACE_MEMBERS: (
    <IconTooltip
      content={<span>Selected people in your Workspace can access</span>}>
      <StyledIcon as={LockIcon} aria-label="Lock icon" />
    </IconTooltip>
  ),
  ONLY_YOU: (
    <IconTooltip content={<span>Only you can access</span>}>
      <StyledIcon as={LockIcon} aria-label="Lock icon" />
    </IconTooltip>
  ),
  WORKSPACE_MEMBERS: null,
}

export interface DocumentCardIconsProps {
  isLibrary?: boolean
  documentSharingStatus: DocumentSharingStatus
}

const DocumentCardIcons = ({
  isLibrary,
  documentSharingStatus,
}: DocumentCardIconsProps) => {
  if (!isLibrary && documentSharingStatus === 'WORKSPACE_MEMBERS') {
    // No icons to show
    return null
  }

  const sharingStatusIcon = sharedStatusToIconMap[documentSharingStatus]

  return (
    <StyledDocumentCardIcons data-testid="document-card-icon-container">
      {sharingStatusIcon}
      {isLibrary && (
        <IconTooltip content={<span>Library</span>}>
          <StyledIcon as={SymbolIcon} aria-label="Library icon" />
        </IconTooltip>
      )}
    </StyledDocumentCardIcons>
  )
}

export default DocumentCardIcons
